import { Theme } from "@mui/material";

// eslint-disable-next-line no-duplicate-imports
import makeStyles from "@mui/styles/makeStyles";
// eslint-disable-next-line no-duplicate-imports
import createStyles from "@mui/styles/createStyles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    cardMain: {
      marginBottom: "0px",
      paddingTop: "2px",
      width: "calc(100%)",
    },
    cardSec: {
      paddingBottom: 0,
    },
    card: {
      boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.5)",
    },
  })
);
